import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-common-input-dialog',
  templateUrl: './common-input-dialog.component.html',
  styleUrls: ['./common-input-dialog.component.scss'],
})
export class CommonInputDialogComponent implements OnInit {
  heading: string;
  form: FormGroup;
  btnLabel: string;
  placeholder: string;
  errorMessage: string;
  country = localStorage.getItem('country');
  minValueError: String;
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _fb: FormBuilder,
    public _matDialogRef: MatDialogRef<CommonInputDialogComponent>
  ) {
    console.log('data', this._data);
    (this.heading = this._data.title),
      (this.btnLabel = this._data.btnLabel),
      (this.placeholder = this._data.placeholder),
      (this.errorMessage = this._data.errorMessage),
      this.createForm();

    if (this.country == 'Ghana') {
      this.minValueError = `You can add minimum ${this._data?.walletData?.minimumGhana} GHS.`;
    } else {
      this.minValueError = `You can add minimum ${this._data?.walletData?.minimumNigeria} NGN.`;
    }
  }

  createForm() {
    const formGroup: any = {
      inputField: [
        '',
        [
          Validators.required,
          Validators.min(
            this.country == 'Ghana'
              ? this._data?.walletData?.minimumGhana
              : this._data?.walletData?.minimumNigeria
          ),
        ],
      ],
      remark: [''],
    };

    this.form = this._fb.group(formGroup);
  }

  ngOnInit(): void { }
  
  onConfirm(): void {
    if (this.form.valid) {
      this._matDialogRef.close(this.form.value);
    }
  }
}
